<template>
  <div>
    <menubar-content-editor v-if="currentApp == apps.Modules.ContentEditor.Id" />
    <menubar-channel-creator v-if="currentApp == apps.Modules.ChannelCreator.Id" />
    <menubar-attribute-manager v-if="currentApp == apps.Modules.AttributeManager.Id" />
    <menubar-export v-if="isExport" />
    <menubar-import v-if="isImport" />
    <menubar-translation-manager v-if="currentApp == apps.Modules.TranslationManager.Id && canCreateTranslationProjects"></menubar-translation-manager>
  </div>
</template>
<script>
import menubarTranslationManager from "@TranslationManager/components/ContextMenuBar.vue";
import { mapState } from "vuex";
import menubarAttributeManager from "../../../AttributeManager/components/ContextMenuBar.vue";
import menubarChannelCreator from "../../../ChannelCreator/components/ContextMenuBar.vue";
import menubarContentEditor from "../../../ContentEditor/components/ContextMenuBar.vue";
import menubarExport from "../../../Exports/components/ContextMenuBar.vue";
import menubarImport from "../../../Imports/components/ContextMenuBar.vue";

import _apps from "../../../services/applications";

export default {
  components: {
    menubarContentEditor,
    menubarChannelCreator,
    menubarAttributeManager,
    menubarExport,
    menubarImport,
    menubarTranslationManager
  },
  computed: {
    ...mapState("metadata", ["contentLanguages"]),
    apps() {
      return _apps;
    },
    currentApp() {
      return this.$route.meta.application;
    },
    importApps() {
      return Object.values(this.apps.Imports)
        .map((x) => x.Id)
        .filter((id) => id !== undefined);
    },
    isImport() {
      return this.importApps.includes(this.currentApp);
    },
    exportApps() {
      return Object.values(this.apps.Exports)
        .concat(Object.values(this.apps.PrintCatalogs))
        .map((x) => x.Id)
        .filter((id) => id !== undefined);
    },
    isExport() {
      const application = typeof this.currentApp === "function" ? this.currentApp(this.$route) : this.currentApp;
      return this.exportApps.includes(application) && this.$route.name !== "fastpage-designer" && this.$route.name !== "fastpage-desktop-designer";
    },
    canCreateTranslationProjects() {
      return this.contentLanguages.available.length > 1;
    }
  }
};
</script>
